module.exports = __webpack_public_path__ + "static/img/desktop_img.02c9450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desktop_img.png
// module id = QQRq
// module chunks = 2